// // Source: https://ui.mantine.dev/component/navbar-nested

// import React, { useState } from "react";
// import {
//   Group,
//   Box,
//   Collapse,
//   ThemeIcon,
//   Text,
//   UnstyledButton,
//   createStyles,
//   Anchor,
// } from "@mantine/core";
// import { ChevronLeft, ChevronRight } from "tabler-icons-react";
// import { useNavigate } from "react-router-dom";

// const useStyles = createStyles((theme) => ({
//   control: {
//     fontWeight: 500,
//     display: "block",
//     width: "100%",
//     padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,
//     color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
//     fontSize: theme.fontSizes.sm,

//     "&:hover": {
//       backgroundColor:
//         theme.colorScheme === "dark"
//           ? theme.colors.dark[7]
//           : theme.colors.gray[0],
//       color: theme.colorScheme === "dark" ? theme.white : theme.black,
//     },
//   },

//   link: {
//     fontWeight: 500,
//     display: "block",
//     textDecoration: "none",
//     padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,
//     paddingLeft: 31,
//     marginLeft: 30,
//     fontSize: theme.fontSizes.sm,
//     color:
//       theme.colorScheme === "dark"
//         ? theme.colors.dark[0]
//         : theme.colors.gray[7],
//     borderLeft: `1px solid ${
//       theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]
//     }`,

//     "&:hover": {
//       backgroundColor:
//         theme.colorScheme === "dark"
//           ? theme.colors.dark[7]
//           : theme.colors.gray[0],
//       color: theme.colorScheme === "dark" ? theme.white : theme.black,
//     },
//   },

//   chevron: {
//     transition: "transform 200ms ease",
//   },
// }));

// export function LinksGroup({
//   icon: Icon,
//   label,
//   initiallyOpened,
//   links,
//   link,
//   hasNumber,
// }) {
//   const { classes, theme } = useStyles();
//   const hasLinks = Array.isArray(links);
//   const [opened, setOpened] = useState(initiallyOpened || false);
//   const ChevronIcon = theme.dir === "ltr" ? ChevronRight : ChevronLeft;
//   const navigate = useNavigate();
//   const items = (hasLinks ? links : []).map((itemLink) => (
//     <Text
//       component="a"
//       className={classes.link}
//       href={itemLink.link}
//       key={itemLink.label}
//       onClick={(event) => {
//         event.preventDefault();
//         navigate(itemLink.link);
//         window.location.reload();
//       }}
//     >
//       {itemLink.label}
//     </Text>
//   ));

//   return (
//     <>
//       <UnstyledButton
//         onClick={() => {
//           if (link && link.length) {
//             window.location.href = link;
//           }
//           setOpened((o) => !o);
//         }}
//         className={classes.control}
//       >
//         <Group position="apart" spacing={0}>
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             <Anchor className="my-1" size={30}>
//               <Icon 
//             style={{ width: 18, height: 18 }} 
//         />
//             </Anchor>
//             <Box className="flex" ml="md">
//               {label}{" "}
//               {hasNumber && (
//                 <div
//                   className="justify-center p-auto ml-4"
//                   style={{
//                     // backgroundColor: "#1b6f8d",
//                     width: "22px",
//                     height: "22px",
//                     color: "white",
//                     textAlign: "center",
                    
//                     borderRadius: "50%",
//                   }}
//                 >
//                   {hasNumber}
//                 </div>
//               )}
//             </Box>
//           </Box>
//           {hasLinks && (
//             <ChevronIcon
//               className={classes.chevron}
//               size={14}
//               //
//               style={{
//                 transform: opened
//                   ? `rotate(${theme.dir === "rtl" ? -90 : 90}deg)`
//                   : "none",
//               }}
//             />
//           )}
//         </Group>
//       </UnstyledButton>
//       {hasLinks ? <Collapse in={opened}>{items}</Collapse> : null}
//     </>
//   );
// }

// import React, { useState } from "react";
// import {
//   Group,
//   Box,
//   Collapse,
//   Text,
//   UnstyledButton,
//   createStyles,
// } from "@mantine/core";
// import { ChevronLeft, ChevronRight } from "tabler-icons-react";
// import { useNavigate, useLocation } from "react-router-dom";

// const useStyles = createStyles((theme) => ({
//   control: {
//     fontWeight: 500,
//     display: "block",
//     width: "100%",
//     padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,
//     color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.black,
//     fontSize: theme.fontSizes.sm,
//     borderRadius: theme.radius.sm,
//     // Smooth transition for hover
//     transition: "all 200ms ease",

//     "&:hover": {
//       backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[0],
//       color: theme.colorScheme === "dark" ? theme.white : theme.black,
//     },
//   },

//   link: {
//     fontWeight: 500,
//     display: "block",
//     textDecoration: "none",
//     padding: `${theme.spacing.xs}px ${theme.spacing.md}px`,
//     paddingLeft: 31,
//     marginLeft: 30,
//     fontSize: theme.fontSizes.sm,
//     color: theme.colorScheme === "dark" ? theme.colors.dark[0] : theme.colors.gray[7],
//     borderLeft: `1px solid ${
//       theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3]
//     }`,
//     transition: "all 200ms ease",

//     "&:hover": {
//       backgroundColor: theme.colorScheme === "dark" ? theme.colors.dark[7] : theme.colors.gray[0],
//       color: theme.colorScheme === "dark" ? theme.white : theme.black,
//     },
//   },

//   // This class handles the "Active" look
//   active: {
//     '&, &:hover': {
//       backgroundColor: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).background,
//       color: theme.fn.variant({ variant: 'light', color: theme.primaryColor }).color,
//     },
//   },

//   chevron: {
//     transition: "transform 200ms ease",
//     color: "#43A3B3", // Matching your original chevron color
//   },
// }));

// export function LinksGroup({
//   icon: Icon,
//   label,
//   initiallyOpened,
//   links,
//   link,
//   hasNumber,
// }) {
//   const { classes, theme, cx } = useStyles();
//   const navigate = useNavigate();
//   const location = useLocation();
  
//   const hasLinks = Array.isArray(links);
//   const [opened, setOpened] = useState(initiallyOpened || false);

//   // Check if current route matches parent link or any child link
//   const isParentActive = link === location.pathname;
//   const isAnyChildActive = hasLinks && links.some((l) => l.link === location.pathname);

//   const ChevronIcon = theme.dir === "ltr" ? ChevronRight : ChevronLeft;

//   const items = (hasLinks ? links : []).map((item) => (
//     <Text
//       component="a"
//       key={item.label}
//       // Apply active class if location matches
//       className={cx(classes.link, { [classes.active]: location.pathname === item.link })}
//       onClick={(event) => {
//         event.preventDefault();
//         if (!item.disabled) {
//           navigate(item.link);
//         }
//       }}
//       sx={{
//         opacity: item.disabled ? 0.5 : 1,
//         cursor: item.disabled ? "not-allowed" : "pointer",
//       }}
//     >
//       {item.label}
//     </Text>
//   ));

//   return (
//     <div className="ml-3">
//       <UnstyledButton
//         onClick={() => {
//           if (hasLinks) {
//             setOpened((o) => !o);
//           } else if (link) {
//             navigate(link);
//           }
//         }}
//         // Highlights parent if it's active OR if one of its children is active
//         className={cx(classes.control, { [classes.active]: isParentActive })}
//       >
//         <Group position="apart" spacing={0}>
//           <Box sx={{ display: "flex", alignItems: "center" }}>
//             <Icon size={18} style={{ width: 18, height: 18 }} />
//             <Box ml="md" sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
//               {label}
//               {hasNumber && (
//                 <div
//                   style={{
//                     backgroundColor: "#1b6f8d",
//                     minWidth: "22px",
//                     height: "22px",
//                     padding: "0 6px",
//                     color: "white",
//                     fontSize: "12px",
//                     fontWeight: 700,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                     borderRadius: "100px",
//                   }}
//                 >
//                   {hasNumber}
//                 </div>
//               )}
//             </Box>
//           </Box>
//           {hasLinks && (
//             <ChevronIcon
//               className={classes.chevron}
//               size={14}
//               style={{
//                 transform: opened
//                   ? `rotate(${theme.dir === "rtl" ? -90 : 90}deg)`
//                   : "none",
//               }}
//             />
//           )}
//         </Group>
//       </UnstyledButton>
//       {hasLinks ? <Collapse in={opened}>{items}</Collapse> : null}
//     </div>
//   );
// }


import React, { useState } from "react";
import { Group, Box, Collapse, Text, UnstyledButton, createStyles } from "@mantine/core";
import { ChevronLeft, ChevronRight } from "tabler-icons-react";
import { useNavigate, useLocation } from "react-router-dom";

const useStyles = createStyles((theme) => ({
  control: {
    // Mapping your .nav-link styles
    display: "flex",
    alignItems: "center",
    height: "42px",
    width: "calc(100% - 40px)",
    margin: "0 20px 6px",
    padding: "0 12px",
    borderRadius: "5px",
    color: "#5f6464",
    fontSize: "14px",
    fontWeight: 500,
    letterSpacing: ".5px",
    lineHeight: "12px",
    cursor: "pointer",
    transition: "all .2s ease",
    backgroundColor: "transparent",

    "&:hover": {
      backgroundColor: "#2089ae1a", // Your specific hover color
      color: "#2089ae",
    },
  },

  // Mapping your .nav-sublink styles (nested items)
  link: {
    display: "flex",
    alignItems: "center",
    height: "38px", // slightly smaller for hierarchy
    width: "calc(100% - 60px)", // more margin for nesting
    margin: "0 20px 4px 40px",
    padding: "0 12px",
    borderRadius: "5px",
    color: "#5f6464",
    fontSize: "13px",
    fontWeight: 500,
    textDecoration: "none",
    transition: "all .2s ease",

    "&:hover": {
      backgroundColor: "#2089ae1a",
      color: "#2089ae",
    },
  },

  // The active state shared by both
  active: {
    backgroundColor: "#2089ae1a !important",
    color: "#2089ae !important",
  },

  chevron: {
    transition: "transform 200ms ease",
    color: "#43A3B3",
  },
}));

export function LinksGroup({
  icon: Icon,
  label,
  initiallyOpened,
  links,
  link,
  hasNumber,
}) {
  const { classes, cx } = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  
  const hasLinks = Array.isArray(links);
  const [opened, setOpened] = useState(initiallyOpened || false);

  // Logic to check active status
  const isParentActive = link === location.pathname;

  return (
    <div className="">
      <UnstyledButton
        onClick={() => {
          if (hasLinks) {
            setOpened((o) => !o);
          } else if (link) {
            navigate(link);
          }
        }}
        // CX merges the base style with the active style if true
        className={cx(classes.control, { [classes.active]: isParentActive })}
      >
        <Group position="apart" spacing={0} sx={{ width: '100%' }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <Icon size={18} style={{ width: 18, height: 18 }} />
            <span style={{ flex: 1 }}>{label}</span>
            
            {hasNumber && (
              <div style={{
                backgroundColor: "#1b6f8d",
                minWidth: "20px",
                height: "20px",
                borderRadius: "50%",
                color: "white",
                fontSize: "11px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "4px"
              }}>
                {hasNumber}
              </div>
            )}
          </Box>

          {hasLinks && (
            <ChevronRight
              className={classes.chevron}
              size={14}
              style={{
                transform: opened ? "rotate(90deg)" : "none",
              }}
            />
          )}
        </Group>
      </UnstyledButton>

      {hasLinks && (
        <Collapse in={opened}>
          {links.map((item) => (
            <Text
              component="a"
              key={item.label}
              className={cx(classes.link, { [classes.active]: location.pathname === item.link })}
              onClick={(e) => {
                e.preventDefault();
                if (!item.disabled) navigate(item.link);
              }}
              sx={{
                opacity: item.disabled ? 0.5 : 1,
                cursor: item.disabled ? "not-allowed" : "pointer",
              }}
            >
              {item.label}
            </Text>
          ))}
        </Collapse>
      )}
    </div>
  );
}